import React from 'react'
import CKEditor from 'ckeditor4-react-advanced'

const PageForm = (props) => {
    return (
        <form onSubmit={props.onSubmit}>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Title</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="title" value={props.title} onChange={props.onChange} />
                        <span className="error">{props.errors.title}</span>
                    </div>
                </div>

                <div className="row">
                    <div className="form-label">
                        <label>Type</label>
                    </div>
                    <div className="form-input">
                        <select
                            name="type"
                            value={props.type}
                            onChange={(event) => props.onChange({
                                target: {
                                    name: 'type',
                                    value: Number(event.target.value)
                                }
                            })}
                        >
                            <option value={0}>SYSTEM</option>
                            <option value={1}>NEWS</option>
                        </select>
                        <span className="error">{props.errors.type}</span>
                    </div>
                </div>

                <div className="row">
                    <div className="form-label">
                        <label>Keywords</label>
                    </div>
                    <div className="form-input">
                        <input type="text" name="keywords" value={props.keywords} onChange={props.onChange} />
                        <span className="error">{props.errors.keywords}</span>
                    </div>
                </div>

                <div className="row">
                    <div className="form-label">
                        <label>Description</label>
                    </div>
                    <div className="form-input">
                        <textarea name="description" value={props.description} onChange={props.onChange} rows={3} />
                        <span className="error">{props.errors.description}</span>
                    </div>
                </div>

                <div className="row">
                    <div className="form-label">
                        <label>Thumbnail</label>
                    </div>
                    <div className="form-input">
                        <input type="file" name="thumbnail" accept="image/*" onChange={props.onChange} />
                        {
                            typeof props.thumbnail === 'string' && props.thumbnail.length > 0 && (
                                <span className="hint">Current: {props.thumbnail}</span>
                            )
                        }
                        {
                            props.thumbnail && typeof props.thumbnail !== 'string' && (
                                <span className="hint">Selected: {props.thumbnail.name}</span>
                            )
                        }
                        <span className="error">{props.errors.thumbnail}</span>
                    </div>
                </div>

                {
                    props.url && (
                        <div className="row">
                            <div className="form-label">
                                <label>URL</label>
                            </div>
                            <div className="form-input readonly-field">
                                <div className="readonly-value">{props.url}</div>
                                <span className="hint">Generated by backend and cannot be edited.</span>
                            </div>
                        </div>
                    )
                }

                <div className="row editor">
                    <div className="form-label">
                        <label>Body</label>
                    </div>
                    <div className="editor-wrap">
                        <CKEditor
                            key={props.keyBody}
                            data={props.body}
                            config={{
                                width: '100%',
                                versionCheck: false
                            }}
                            onChange={(event) => {
                                const data = event.editor.getData()
                                props.onChange({
                                    target: {
                                        name: 'body',
                                        value: data
                                    }
                                })
                            }}
                        />
                        <span className="error">{props.errors.body}</span>
                    </div>
                </div>
            </div>

            <div className="actions">
                <button type="submit" disabled={props.submitting}>{props.action}</button>
                <button type="reset" onClick={props.onCancel} disabled={props.submitting}>Cancel</button>
            </div>
        </form>
    )
}

export default PageForm
